import * as z from "zod";

/** Progress of the team's one-time Shopify fulfillment backsync, keyed by team. */
export const getFulfillmentBacksyncProgress = {
  name: "getFulfillmentBacksyncProgress" as const,
  input: z.object({}),
  output: z.object({
    status: z.enum(["not_started", "running", "done", "failed"]),
    processed: z.number().int().nonnegative(),
    synced: z.number().int().nonnegative(),
    /** Null when Shopify gave no usable count; show an indeterminate bar. */
    estimatedTotal: z.number().int().nonnegative().nullable(),
    startedAt: z.string().nullable(),
  }),
};
